import { render, staticRenderFns } from "./ScratchArea.vue?vue&type=template&id=502e229f&scoped=true&"
import script from "./ScratchArea.vue?vue&type=script&lang=js&"
export * from "./ScratchArea.vue?vue&type=script&lang=js&"
import style0 from "./ScratchArea.vue?vue&type=style&index=0&id=502e229f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502e229f",
  null
  
)

export default component.exports